// Generated from design-tokens/tokens/*.tokens.json — do not edit by hand.
// Regenerate with: node design-tokens/scripts/generate.mjs
// antd theme tokens mapped onto the semantic system (design ruling R1).

export const antdTokens = {
  colorPrimary: "#2569F9",
  colorPrimaryHover: "#074FE9",
  colorPrimaryActive: "#0644C6",
  colorPrimaryText: "#2569F9",
  colorPrimaryTextHover: "#074FE9",
  colorPrimaryBg: "#EDF3FF",
  colorPrimaryBgHover: "#CADBFE",
  colorPrimaryBorder: "#2569F9",
  colorPrimaryBorderHover: "#074FE9",
  colorInfo: "#2569F9",
  colorInfoHover: "#074FE9",
  colorInfoActive: "#0644C6",
  colorInfoTextHover: "#074FE9",
  colorInfoTextActive: "#0644C6",
  colorInfoBg: "#EDF3FF",
  colorInfoBgHover: "#CADBFE",
  colorInfoBorder: "#2569F9",
  colorInfoBorderHover: "#074FE9",
  colorTextBase: "#263247",
  colorText: "#263247",
  colorTextSecondary: "#4F5A6F",
  colorTextTertiary: "#707A8B",
  colorTextQuaternary: "#9299A6",
  colorBorder: "#E6E7EA",
  colorBorderSecondary: "#E6E7EA",
  colorSuccess: "#2BAB55",
  colorWarning: "#FAB800",
  colorError: "#E9071C",
  borderRadius: 4,
  borderRadiusSM: 2,
  borderRadiusLG: 8,
} as const;

export const antdComponentTokens = {
  Menu: {
    itemHoverBg: "#EDF3FF",
  },
  Radio: {
    colorBorder: "#707A8B",
  },
  Checkbox: {
    colorBorder: "#707A8B",
  },
} as const;
